import { Form } from '@unform/web';
import { CompactSearch, CompactSelect } from 'components/Shared';
import { FindMany, SelectOption } from 'contracts/Common';
import { throttle } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import * as S from './styles';

type SearchField = 'id' | 'document' | 'name' | 'city' | 'state';

export interface FindCarriers extends FindMany {
  searchField?: SearchField;
}

const searchFieldOptions: SelectOption[] = [
  { label: 'ID', value: 'id' },
  { label: 'Documento', value: 'document' },
  { label: 'Nome', value: 'name' },
  { label: 'Cidade', value: 'city' },
  { label: 'Estado', value: 'state' },
];

interface Props {
  onFilter?: (query: FindCarriers) => void;
  currentFilter: FindCarriers;
  delay?: number;
}

export const CarrierFilters: React.FC<Props> = ({
  delay = 1000,
  currentFilter,
  onFilter,
}) => {
  const [filters, setFilters] = useState<FindCarriers>({
    ...currentFilter,
    dirty: false,
  });

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      setFilters((state) => ({
        ...state,
        dirty: true,
        search: e.target.value,
      }));
    },
    []
  );

  const handleSearchField = useCallback((option: SelectOption | null): void => {
    if (!option) return;
    setFilters((state) => ({
      ...state,
      dirty: true,
      searchField: option.value as SearchField,
    }));
  }, []);

  const selectedSearchField = useMemo(
    () =>
      searchFieldOptions.find(
        (option) => option.value === filters.searchField
      ) ||
      searchFieldOptions.find((option) => option.value === 'name') ||
      searchFieldOptions[0],
    [filters.searchField]
  );

  // throttled methods

  const onSearch = useMemo(
    () => throttle(handleSearch, delay),
    [delay, handleSearch]
  );

  const invokeOnFilter = useCallback((): void => {
    if (filters.dirty && onFilter) {
      onFilter(filters);
    }
  }, [filters, onFilter]);

  useEffect(() => {
    invokeOnFilter();
  }, [invokeOnFilter]);

  return (
    <S.Container>
      <Form onSubmit={() => {}}>
        <CompactSearch
          onChange={onSearch}
          defaultValue={filters?.search}
          placeholder="Buscar"
          name="search"
          aria-label="Buscar"
        />
        <CompactSelect
          name="searchField"
          inputId="carriers-search-field"
          aria-label="Buscar por"
          options={searchFieldOptions}
          value={selectedSearchField}
          onChange={handleSearchField}
          isSearchable={false}
        />
      </Form>
    </S.Container>
  );
};
